import { Directive, HostListener, ElementRef, OnInit } from '@angular/core';
import { DecimalPipe } from '@angular/common';

@Directive({ selector: '[myWalletCurrencyFormatter]' })
export class MyWalletCurrencyFormatterDirective implements OnInit {
  private el: HTMLInputElement;

  constructor(
    private elementRef: ElementRef<HTMLInputElement>,
    private currencyPipe: DecimalPipe
  ) {
    this.el = this.elementRef.nativeElement;
  }

  ngOnInit() {
    this.el.value = this.formatCurrency(this.el.value);
  }

  private formatCurrency(value: string): string {
    // Remove non-numeric and non-decimal characters
    const cleanedValue = value.replace(/[^\d.]/g, '');
    // Format the value with comma as thousands separator
    const formattedValue = this.currencyPipe.transform(cleanedValue, '1.0-0');
    return formattedValue || ''; // If transformation fails, set value to empty string
  }

  @HostListener('input', ['$event.target.value'])
  onInput(value) {
    this.el.value = this.formatCurrency(value);
  }

  @HostListener('focus', ['$event.target.value'])
  onFocus(value) {
    this.el.value = value.replace(/[^\d.]/g, '');
  }

  @HostListener('blur', ['$event.target.value'])
  onBlur(value) {
    this.el.value = this.formatCurrency(value);
  }
}
